/** @format */

import { createApp } from "vue";
import "@/assets/css/element.scss";
import ElementPlus from "element-plus";
// import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import LogicFlow from "@logicflow/core";
import "@logicflow/core/dist/style/index.css";
import {
    DndPanel,
    SelectionSelect,
    Menu,
    NodeResize,
    Snapshot,
} from "@logicflow/extension";
import "@logicflow/extension/lib/style/index.css";
import html2canvas from "html2canvas";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import ajax from "@/ajax";
import { storeInit } from "@/store/index.js";
import VueParticles from "vue-particles";

import "@/assets/css/base.scss";
import "@/assets/css/iconfont.css";
import "@/assets/css/animate.css";
// router.beforeEach((to, from, next) => {
//     if (to.meta && to.meta.permissions && app.config.globalProperties.permissionsTest(to.meta.permissions)) {
//         return
//     }
//     next()
// })

var app = createApp(App);
app.use(ElementPlus);
app.use(createPinia());
app.use(router);
app.use(VueParticles);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
}

LogicFlow.use(DndPanel);
LogicFlow.use(SelectionSelect);
LogicFlow.use(Menu);
LogicFlow.use(NodeResize);
LogicFlow.use(Snapshot);

ajax.store = storeInit();
app.config.globalProperties._ajax = ajax;

app.config.globalProperties.LogicFlow = LogicFlow;
app.config.globalProperties.html2canvas = html2canvas;
app.config.globalProperties.routerReplace = function (name, data) {
    if (!name) {
        return;
    }
    this.$router.replace({
        name: name,
        query: data,
    });
};
app.config.globalProperties.routerPush = function (name, data = {}) {
    if (!name) {
        return;
    }

    // 0:审核中
    // 9:审核未通过
    // 1:审核通过但无权限
    // 8:学校权限到期
    // 2:正常 有权限
    // console.log(name);
    // console.log(this._ajax.store.user.UserInfoID);
    // console.log(Object.keys(data).length !== 0)
    if (
        this._ajax.store.user.UserInfoID && (name !== "index" && Object.keys(data).length !== 0)
    ) {
        // console.log(this._ajax.store.user.UserType);
        const isShareCase = data && data.route === "share_case";
        // 已登录
        if (this._ajax.store.user.UserType === 2 || isShareCase) {
            this.$router.push({
                name: name,
                query: data,
            });
        } else if (this._ajax.store.user.UserType === 9) {
            this.$message.warning("您的审核尚未通过，请等待!");
            return;
        } else {
            if(data.route == 'customized_case'){
                // 定制案例库权限验证
                this._ajax.post({
                    url: "CheckUserLicenseType",
                    data: {
                        TypeName:data.route,
                    },
                    success: (res) => {
                        if(res.Results == 1){ 
                            this.$router.push({
                                name: name,
                                query: data,
                            });
                        } else {
                            this.$message.warning("暂无访问权限!");
                            return;
                        }
                    },
                    fail() {
                        this.loading = false;
                    },
                });
            }else{
                this.$message.warning("暂无访问权限!");
                return;
            }
            
        }
    } else {
        // 未登录
        this.$router.push({
            name: name,
            query: data,
        });
    }

    // if()
    /*if (this._ajax.store.user.user_category == '机构') {
        if ([
                //
                "announcement_Third",
                "announcement_Bond",
                "announcement_HongKongShares",
                "announcement_Fund",
                "announcement_Supervise",
                "information_F",
            ].indexOf(name) != -1) {
            this.$message({
                type: 'warning',
                message: "您目前暂无此功能权限。"
            })
            return
        }
    }*/
};
app.config.globalProperties.routerResolve = function (name, data) {
    if (!name) {
        return;
    }
    let routeUrl = this.$router.resolve({
        path: "/home/" + name,
        query: data,
    });
    window.open(routeUrl.href, "_blank");
};
app.config.globalProperties.permissionsTest = function (name) {
    if ((ajax.store.user.WebUrlName || []).indexOf(name) == -1) {
        this.$alert(
            "您没有当前功能权限！请前往用户中心-会员中心购买对应权限。",
            "暂无权限",
            {
                // showClose: false,
                confirmButtonText: "前往",
                callback: (action) => {
                    if (action == "confirm") {
                        this.routerReplace("vip");
                    }
                },
            }
        );
        return true;
    }
    return false;
};
app.config.globalProperties.userQuit = function (name, data) {
    localStorage.Authorization_vcase = "";
    sessionStorage.Authorization_vcase = "";
    localStorage.VCASE_user = "";
    location.href = "/";
};
app.config.globalProperties._textOverTest = function (form, key, num) {
    if (form[key] && form[key].length > num) {
        this.$message({
            type: "success",
            message: "文字过长",
        });
        form[key] = form[key].slice(0, num);
    }
};
app.config.globalProperties._textKTest_A = function (form, key, k) {
    var arr = form[key].match(k);
    var str = arr.join("");
    if (form[key] != str) {
        this.$message({
            type: "success",
            message: "文字被整理",
        });
    }
    form[key] = str;
};
app.config.globalProperties.tagClose = function (list, index) {
    list.splice(index, 1);
};
app.config.globalProperties.openFun = function (path) {
    if (!path) {
        return;
    }
    // window.open(link)
    const link = document.createElement("a");
    link.href = path;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
app.config.globalProperties.goBack = function (link) {
    this.$router.back();
};
app.config.globalProperties.createDownLoadClick = function (content, fileName) {
    const link = document.createElement("a");
    link.href = content;
    link.download = fileName;
    var ev = document.createEvent("MouseEvents");
    ev.initMouseEvent(
        "click",
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
    );
    link.dispatchEvent(ev);
};

app.config.globalProperties.isLogin = function (name, data) {
    if (this._ajax.store.user.UserName || this._ajax.store.user.UserAccount) {
        return true;
    } else {
        return false;
    }
};

// function setDynamicFavicon() {
//     // 读取 localStorage 中存储的图标地址（登录时存入）
//     // const faviconUrl = localStorage.getItem('faviconUrl');
//     const faviconUrl = localStorage.VCASE_user.path;
//     console.log("localStorage.VCASE_user:", localStorage.VCASE_user);
//     if (!faviconUrl) return; // 无地址则不修改

//     // 查找页面中已有的 favicon 标签
//     let link = document.querySelector('link[rel="icon"]');

//     if (link) {
//         // 存在则更新 href
//         link.href = faviconUrl;
//     } else {
//         // 不存在则创建新标签
//         link = document.createElement("link");
//         link.rel = "icon";
//         link.href = faviconUrl;
//         document.head.appendChild(link);
//     }
// }

// // 初始化动态
// setDynamicFavicon();

app.mount("#app");
